function PlayerConfig(defaultPlayerName) {

    /**
     * @returns {{setItem, getItem}}
     */
    function getStorage() {

        var TEST_KEY = '__localStorage__testKey';
        var TEST_VALUE = '__localStorage__testValue';

        try {
            localStorage.setItem(TEST_KEY, TEST_VALUE);
            if (localStorage.getItem(TEST_KEY) === TEST_VALUE) {
                localStorage.removeItem(TEST_KEY);
                return localStorage;
            }
        } catch (error) {
        }

        var hashStorage = Params.fromHash();
        return {
            getItem: function (key) {
                return hashStorage[key];
            },
            setItem: function (key, value) {
                hashStorage[key] = value;
                location.hash = '#' + hashStorage.toString();
            }
        }
    }


    var key = 'PlayerConfig.player';
    var storage = getStorage();

    function getPlayerName() {
        return storage.getItem(key) || defaultPlayerName;
    }

    function setAndReload(playerName) {
        storage.setItem(key, playerName);
        location.reload();
    }

    return {
        getPlayerName: getPlayerName,
        setAndReload: setAndReload
    }

}